__turbopack_context__.v({
  "emptyStateWrapper": "XajtxG_emptyStateWrapper",
  "ordersNumber": "XajtxG_ordersNumber",
  "tabsWrapper": "XajtxG_tabsWrapper",
  "title": "XajtxG_title",
});
